import * as yup from 'yup'
import {
  dobSchema,
  emailSchema,
  firstNameSchema,
  genderSchema,
  lastNameShema,
  otherNameSchema,
  phoneNumberSchema
} from './userSchema'

export const addPatientSchema = yup.object({
  charge_registration_fee: yup.boolean().default(true),
  date_of_birth: dobSchema.required('Select your date of birth'),
  email: emailSchema.notRequired(),
  first_name: firstNameSchema,
  gender: genderSchema,
  last_name: lastNameShema,
  middle_name: otherNameSchema,
  phone_number: phoneNumberSchema
})
